import styled from 'styled-components';
import { colors } from '../../../theme/colors';
import Typography from '../../Typography';

const getBrandPrimary = (props) => (props.theme && props.theme.colors && props.theme.colors.brand && props.theme.colors.brand.primary) || colors.brandDarkBlue;
const getBrandSecondary = (props) => (props.theme && props.theme.colors && props.theme.colors.brand && props.theme.colors.brand.secondary) || colors.brandLightBlue;
const getTextSecondary = (props) => (props.theme && props.theme.colors && props.theme.colors.text && props.theme.colors.text.secondary) || '#666';

export const FileInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 600px;
`;

export const UploadArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  border-radius: 4px;
  border: 1px dashed ${props => {
    if (props.error) return colors.danger;
    if (props.isDragActive) return colors.brandDarkBlue;
    if (props.disabled) return '#e0e0e0';
    return colors.brandLightGray;
  }};
  background-color: ${props => {
    if (props.isDragActive) return colors.brandIce;
    if (props.disabled) return '#f8f9fa';
    if (props.error) return '#fffafb';
    return '#ffffff';
  }};
  transition: all 0.2s ease-in-out;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};

  &:hover {
    border-color: ${props => (!props.disabled && !props.error ? colors.brandDarkBlue : '')};
  }
`;

export const DragContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const FileList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FileItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background-color: #f8f9fa;
  border: 1px solid ${props => (props.error ? colors.danger : '#e0e0e0')};
  border-radius: 4px;
`;

export const FileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const ProgressBarContainer = styled.div`
  width: 100%;
  height: 4px;
  background-color: #e0e0e0;
  border-radius: 2px;
  margin-top: 8px;
  overflow: hidden;
`;

export const ProgressBarFill = styled.div`
  height: 100%;
  background-color: ${props => getBrandPrimary(props)};
  width: ${props => props.progress || 0}%;
  transition: width 0.3s ease;
`;

export const ActionButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  background-color: ${props => getBrandPrimary(props)};
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${props => getBrandSecondary(props)};
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

export const DeleteButton = styled(ActionButton)`
  background-color: ${props => (props.error ? colors.danger : colors.brandDarkBlue)};
  
  &:hover {
    background-color: ${props => (props.error ? '#c82333' : colors.brandLightBlue)};
  }
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const ErrorText = styled(Typography)`
  color: ${colors.danger};
  font-size: 12px;
  margin-top: 4px;
`;

export const HelperText = styled(Typography)`
  color: ${props => getTextSecondary(props)};
  font-size: 12px;
  margin-top: 8px;
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/FileInput/components/FileInputStyles.js